import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconName, PalleteColor } from 'nanaykuna-ui-kit/loader';

type AccessHeaderTone = 'neutral' | 'success' | 'error';

const TONE_CIRCLE: Record<AccessHeaderTone, string> = {
  neutral: 'bg-neutral-200',
  success: 'bg-feedback-success-light',
  error: 'bg-feedback-error-light',
};

const TONE_ICON: Record<AccessHeaderTone, PalleteColor> = {
  neutral: 'neutral-900',
  success: 'feedback-success-dark',
  error: 'feedback-error-dark',
};

/**
 * Header shared by every access screen (login, recovery, new password):
 * optional back link, icon circle, display title and subtitle.
 */
@Component({
  standalone: false,
  selector: 'digicem-access-header',
  templateUrl: './access-header.component.html',
})
export class AccessHeaderComponent {
  @Input() icon: IconName = 'lock';
  // Not `title`: a static `title="…"` would also land on the host element as
  // the native attribute and show a browser tooltip over the whole header.
  @Input() heading = '';
  @Input() subtitle = '';
  @Input() tone: AccessHeaderTone = 'neutral';
  /** Label of the back link; the link is hidden when empty. */
  @Input() backLabel = '';

  @Output() back = new EventEmitter<void>();

  protected get circleClass(): string {
    return TONE_CIRCLE[this.tone];
  }

  protected get iconFill(): PalleteColor {
    return TONE_ICON[this.tone];
  }
}
